import Button from 'components/reusable/Button';
import { FlexRow } from 'components/reusable/grid-elements/flex-row';
import { PFontw4s16h24 } from 'components/reusable/Fonts';
import { trackEvent } from 'lib/analytics';
import styled from 'styled-components';
import HomeLayout from 'components/layout/home-layout';
import { GlobalTokenStyles } from '@seed-health/tokens/react';

const PageWrapper = styled.div`
  margin: 5rem 2rem;
  max-width: 1440px;

  h1 {
    color: var(--primary-green, #1c3a13);
    font-size: 40px;
    font-style: normal;
    font-weight: 350;
    line-height: 48px; /* 120% */
    letter-spacing: -0.4px;
  }

  @media (min-width: 769px) {
    margin: 5rem;
  }
`;

const SiteDown = () => {
  const refreshPage = () => {
    trackEvent('Button Clicked', {
      buttonName: 'Refresh Page',
    });
    window.location.reload();
  };

  return (
    <HomeLayout>
      <GlobalTokenStyles />
      <PageWrapper>
        <FlexRow theme={{ margin: '0 0 1rem 0 ' }}>
          <h1 className='title'>Sorry, Something Went Wrong</h1>
        </FlexRow>
        <FlexRow theme={{ margin: '0 0 1rem 0 ' }}>
          <PFontw4s16h24>
            Something unexpected happened, and our team has been notified of
            this error.
          </PFontw4s16h24>
        </FlexRow>
        <FlexRow theme={{ margin: '0 0 1rem 0 ' }}>
          <PFontw4s16h24>Refresh the page to continue.</PFontw4s16h24>
        </FlexRow>
        <FlexRow>
          <Button theme={{ maxWidth: '264px' }} onClick={refreshPage}>
            Refresh the Page
          </Button>
        </FlexRow>
      </PageWrapper>
    </HomeLayout>
  );
};

export default SiteDown;
